import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import {
  ICadenceTemplateCreate,
  ICadenceTemplateRead,
  ICadenceTemplateStep,
} from "../Types/socialPromptCadenceTemplate";

/** Strip any per-step `voice_key`; templates only persist channel + objective. */
const sanitizeSteps = (steps: ICadenceTemplateStep[]): ICadenceTemplateStep[] =>
  steps.map((step) => ({
    content_type: step.content_type,
    objective: step.objective ?? null,
  }));

/** Create a new private cadence template (backend returns 201). */
export const createSocialPromptCadenceTemplate = async (
  payload: ICadenceTemplateCreate
): Promise<ICadenceTemplateRead> => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/social-prompt-cadence-templates/`;

  const body: ICadenceTemplateCreate = {
    title: payload.title,
    is_default: payload.is_default ?? false,
    voice_key: payload.voice_key ?? null,
    context: payload.context ?? null,
    steps: sanitizeSteps(payload.steps),
  };

  const response = await axios.post<ICadenceTemplateRead>(URL, body, {
    headers: {
      Authorization: `Bearer ${user.access_token}`,
    },
  });

  return response.data;
};
